import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetTeaForm, GetTeaFormResponse} from 'domain/usecases/private/tea-flow/get-tea-form';

export class RemoteGetTeaForm implements GetTeaForm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetTeaFormResponse>,
	) {}

	async get(): Promise<GetTeaFormResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
